/* s13-animations.js — shared motion behaviors for the 613 (s13-*) sections.
   Opt in from markup:
     data-s13-chars     on a heading  → per-character random fade-in on scroll (theme text reveal)
     data-s13-cascade   on a container → direct children fade up in sequence on scroll
     data-s13-countup   on an element  → counts a leading number up to its value on scroll (no-op if not a plain number)
     class s13-zoom / s13-lift / s13-btn-swap are CSS-only (see s13-animations.css)
   Idempotent: safe to load more than once and re-scans on shopify:section:load. Reduced-motion aware. */
(function () {
  if (window.__s13Anim) { window.__s13Anim.scan(); return; }

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var HAS_IO = 'IntersectionObserver' in window;

  function whenVisible(el, cb) {
    if (!HAS_IO) { cb(); return; }
    var o = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) { if (e.isIntersecting) { o.unobserve(e.target); cb(); } });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    o.observe(el);
  }

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }

  function initChars(el) {
    if (el.dataset.s13CharsReady) return; el.dataset.s13CharsReady = '1';
    if (REDUCE || el.querySelector('.s13-char')) return; // leave text visible/as-is
    var text = el.textContent;
    if (!text.trim()) return;
    el.setAttribute('aria-label', text.trim()); // keep the heading readable to assistive tech
    el.textContent = '';
    var spans = [];
    for (var i = 0; i < text.length; i++) {
      var ch = text[i];
      if (ch === ' ') { el.appendChild(document.createTextNode(' ')); continue; }
      var s = document.createElement('span');
      s.className = 's13-char'; s.setAttribute('aria-hidden', 'true'); s.textContent = ch;
      el.appendChild(s); spans.push(s);
    }
    el.classList.add('s13-anim-ready');
    var step = Math.min(0.08, 0.9 / Math.max(spans.length, 1));
    shuffle(spans.map(function (_, i) { return i; })).forEach(function (idx, pos) {
      spans[idx].style.transitionDelay = (pos * step).toFixed(3) + 's';
    });
    whenVisible(el, function () { el.classList.add('s13-chars-in'); });
  }

  function initCascade(el) {
    if (el.dataset.s13CascadeReady) return; el.dataset.s13CascadeReady = '1';
    if (REDUCE) return;
    el.classList.add('s13-anim-ready');
    var kids = el.children, step = 0.07;
    for (var i = 0; i < kids.length; i++) { kids[i].style.transitionDelay = (i * step).toFixed(3) + 's'; }
    whenVisible(el, function () { el.classList.add('s13-cascade-in'); });
  }

  function initCountup(el) {
    if (el.dataset.s13CountupReady) return; el.dataset.s13CountupReady = '1';
    if (REDUCE) return;
    var raw = el.textContent.trim();
    var m = raw.match(/^(\D*)(\d[\d,]*)(.*)$/);
    if (!m) return;                       // no leading number
    if (/\d/.test(m[3])) return;          // another number in the suffix (e.g. a range) → skip
    var prefix = m[1], target = parseInt(m[2].replace(/,/g, ''), 10), suffix = m[3];
    if (isNaN(target)) return;
    whenVisible(el, function () {
      var dur = 800, start = null;
      function tick(t) {
        if (!start) start = t;
        var p = Math.min((t - start) / dur, 1), e = 1 - Math.pow(1 - p, 3);
        el.textContent = prefix + Math.round(e * target) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }

  function scan(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-s13-chars]').forEach(initChars);
    scope.querySelectorAll('[data-s13-cascade]').forEach(initCascade);
    scope.querySelectorAll('[data-s13-countup]').forEach(initCountup);
  }

  window.__s13Anim = { scan: scan };
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', function () { scan(); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
